export default __webpack_public_path__ + "static/media/sound-on.d50e95d1.svg";